'use client';
import { useEffect } from 'react';

export function GladlyFaq() {
  const gladlyDomain = process.env.NEXT_PUBLIC_GLADLY_DOMAIN
  const cdn = process.env.ENV === 'prod' ? 'https://cdn.gladly.com' : 'https://cdn.gladly.qa';
  const orgId = process.env.NEXT_PUBLIC_GLADLY_ORG_ID;
  const src = `/gladly-help-center.html?gladlyDomain=${gladlyDomain}&cdn=${cdn}&orgId=${orgId}`;

  useEffect(() => {
    // Force scroll behavior
    const handleMessage = (event: { data: { type: string; source: string } }) => {
      // Verify the message is from our Gladly help center
      if (
        event.data &&
        event.data.type === 'gladly-scroll-to-top' &&
        event.data.source === 'gladly-help-center'
      ) {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Alternative: scroll to the iframe specifically if you want
        // const iframe = document.querySelector('iframe[title="Gladly Help Center"]');
        // if (iframe) {
        //   iframe.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // }
      }
    };

    // Add event listener
    window.addEventListener('message', handleMessage);

    // Cleanup
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <iframe
      src={src}
      title="Gladly Help Center"
      style={{ width: '100%', height: '1000px', border: 'none' }}
      sandbox="allow-scripts allow-same-origin allow-top-navigation-by-user-activation"
    />
  );
}
